import { render, staticRenderFns } from "./UserStatsOverride.vue?vue&type=template&id=16c26831"
import script from "./UserStatsOverride.vue?vue&type=script&lang=js"
export * from "./UserStatsOverride.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports